<template>
  <div>
    <page-header :page="page" />
    <filter-manager
      ref="filter"
      v-model="filterModel"
      :filters="filterManagerConfig.basic.concat(filterManagerConfig.advanced)"
      :open-advanced="true"
      @academicYear="onChangeAcademicYear"
      @center="onChangeCenters"
      @month="onChangeMonth"
      @provider="onChangeProvider"
      @search="onSearchHandler"
      @specialist="onChangeSpecialist"
    />
    <custom-separator class="pt-3" text="Resultado de Referidos" />
    <div v-if="specialistInfoData && hasResults" class="mt-4">
      <div class="specialist-container mb-3 pb-2 mt-3">
        <div class="row py-3">
          <div class="d-flex align-items-center col-md-3">
            <div class="d-flex flex-column">
              <div class="d-flex align-items-start">
                <em
                  class="title-icon font-18 color-primary-1 fa fa-file mr-1"
                />
                <div class="d-flex flex-column">
                  <span class="color-secondary-6 font-14 ml-1">
                    Cantidad de Servicio
                  </span>
                  <div class="color-black font-32 font-weight-bold">
                    {{ specialistInfoData.total }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-md-3 d-flex align-items-center justify-content-center"
            :class="{ 'col-md-6': !canShowStatus }"
          >
            <div
              class="text-center indicator-size"
              :class="getPeriodIndicatorClass"
            >
              <span>
                {{ getPeriodIndicatorLabel }}
              </span>
            </div>
          </div>
          <div
            v-if="canShowStatus"
            class="col-md-3 d-flex align-items-center justify-content-center"
          >
            <div
              class="text-center indicator-size"
              :class="getPeriodIndicatorStatusClass"
            >
              <span>{{ getPeriodIndicatorStatusLabel }}</span>
            </div>
          </div>
          <div class="col-md-3 d-flex justify-content-end align-items-center">
            <action-button
              v-if="canFinalizePeriod"
              :i="getButtonIcon"
              text="Guardar"
              variant="outline-success px-4 transparent-color bg-transparent"
              @click="doAction"
            >
              {{ getActionButtonLabel }}
            </action-button>
          </div>
        </div>
      </div>
      <div v-for="(item, index) in results" :key="'visit-registry' + index">
        <custom-callout
          :border-color="getBorderColor"
          class="mb-3 custom-callout"
          :show-edition="item.isOpen"
        >
          <div class="row">
            <div class="col-md-1 col-sm-12 icon-container">
              <div class="toggle-icon">
                <em
                  :class="toggleClass(item.isOpen)"
                  @click="
                    () => {
                      tabIndex = 0;
                      onToggleAdditionalInfo(item, index);
                    }
                  "
                />
              </div>
              <div class="separator-line" />
            </div>
            <div
              v-if="!item.isEducativeService"
              class="col-md-2 col-sm-12 col-spacing"
            >
              <div class="legend font-14">
                Número de Referido:
              </div>
              <div class="font-weight-normal text-black">
                {{ item.referralNumber }}
              </div>
            </div>
            <div v-else class="col-md-2 col-sm-12 col-spacing">
              <div class="legend font-14">
                Número de Solicitud:
              </div>
              <div class="font-weight-normal text-black">
                {{ item.referralNumber }}
              </div>
            </div>
            <div class="col-md-2 col-sm-12 col-spacing">
              <div class="legend font-14">
                Servicio:
              </div>
              <div class="font-weight-normal text-black">
                {{ item.disciplineDescription }}
              </div>
            </div>
            <div class="col-md-3 col-sm-12 col-spacing">
              <div class="legend font-14">
                Estudiante:
              </div>
              <div class="font-weight-normal text-black">
                {{ item.studentFullName }}
              </div>
            </div>
            <div class="col-md-2 col-sm-12 col-spacing service-place-spacing">
              <div class="legend font-14">
                SIE:
              </div>
              <div class="font-weight-normal text-black">
                {{ item.studentSieId }}
              </div>
            </div>
            <div class="col-md-1 col-sm-12 col-spacing service-place-spacing">
              <div class="legend font-14">
                Conteo:
              </div>
              <div class="font-weight-normal text-black">
                {{ item.visits?.length ? item.visits.length : '-' }}
              </div>
            </div>
            <div
              class="col-md-2 col-sm-12 col-spacing d-flex align-items-center"
            >
              <dropdown
                id="dropdownActions"
                class="actions-dropdown"
                :data-item="{ item, index }"
                :items="actionItems"
                title=" Acciones "
              />
            </div>
          </div>

          <template
            v-if="item.isOpen"
            #edition
            class="p-3 pb-2 custom-callout-edition"
          >
            <div class="info-panel">
              <b-tabs
                v-model="tabIndex"
                active-nav-item-class="mipe-tab font-weight-bold text-green active-nav-item-custom"
                active-tab-class=""
                content-class="mt-3"
                nav-class="custom-nav-container"
                :no-nav-style="true"
              >
                <b-tab active title="Información Adicional">
                  <educative-additional-info
                    v-if="item.isEducativeService"
                    :assignment-end-date="dateFormat(item.assignmentEndDate)"
                    :assignment-start-date="
                      dateFormat(item.assignmentStartDate)
                    "
                    :value="item.educationServiceInfo || {}"
                  />
                  <div v-else>
                    <additional-info :data="item" />
                  </div>
                </b-tab>
                <b-tab :active="tabIndex === 1" title="Detalle de Visitas">
                  <visit-details :data="item.visits" />
                </b-tab>
                <b-tab title="Información de Lugar de Servicio">
                  <location-service-info :data="item" />
                </b-tab>
              </b-tabs>
            </div>
          </template>
        </custom-callout>
        <!-- <div --- Temp--- Don't remove commented
          v-if="
            item.isEducativeService &&
              !item.isPeiSigned &&
              !item.isItinerantService
          "
          class="bg-secondary-19 p-2 rounded mt-n3 mb-3"
        >
          <div
            class="color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
          >
            <em class="fas fa-file-invoice pl-2 ml-1 color-primary-4" />
            <div class="ml-2 no-eligible-message pl-2 color-secondary-20">
              No cuenta con un PEI del año corriente firmado en sistema.
            </div>
          </div>
        </div> -->
        <div v-if="item.hasErrorFlag" class="visit-error-container">
          <error
            v-for="(errorMessage, errorIndex) in item.errorMessages"
            :key="`validation-container-visit` + errorIndex"
            :message="errorMessage"
            variant="no-border"
          />
        </div>
        <div
          v-if="isInterventionPlanNotSubmited(item)"
          class="visit-error-container"
        >
          <error
            :message="
              'No cuenta con un plan de intervención. Favor de registrar un plan de intervencion antes de finalizar periodo.'
            "
            variant="no-border"
          />
        </div>
      </div>
    </div>
    <custom-result-not-found v-if="results != null && results.length === 0" />
    <pagination
      v-if="pagination.totalRecords > pageSize"
      :data="pagination"
      show-text
      @pagination-go-page="goToPageHandler"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import PageHeader from '@/components/common/page/PageHeader';
import CustomSeparator from '@/components/common/CustomSeparator';
import { ActionButton, CustomDropDown, Error } from '@/components/common';
import CustomCallout from '@/components/common/CustomCallout';
import Pagination from '@/components/common/Pagination.vue';
import alertMixin from '@/mixins/alert.mixin.js';
import { name } from '@/modules/periodEnd/store';
import { ACTION_TYPES, MUTATION_TYPES } from '@/modules/periodEnd/store/types';
import { createNamespacedHelpers } from 'vuex';
import FilterManager from 'FilterManager';
import roles from '@/utils/constants/roles.js';
import customResultNotFound from 'custom-result-not-found';
import Dropdown from 'dropdown';
const {
  mapActions,
  mapState,
  mapGetters,
  mapMutations,
} = createNamespacedHelpers(name);
import thrpyBillingTransactionType from '@/utils/constants/thrpyBillingTransactionType.js';
import periodEndStatus from '@/utils/constants/periodEndStatus.js';
const VISIT_VALIDATION_ROUTE_NAME = 'ValidateVisit';
import { getVisitStudentInfo } from '@/modules/billingHistory/api';
import storeMixin from 'utils/mixins/storeGenerator';
import disciplineTypeCodes from '@/utils/constants/disciplineTypeCode';
const DEFAULT_PAGE_SIZE = 10;
import EducativeAdditionalInfo from '@/components/common/visits/EducativeAdditionalInfo';
import { getList as _getServiceLocations } from '@/modules/shared/servicelocation.api';
import {
  AdditionalInfo,
  LocationServiceInfo,
  VisitDetails,
} from './components';

export default {
  name: 'ProviderPeriodEnd',
  components: {
    EducativeAdditionalInfo,
    PageHeader,
    CustomSeparator,
    ActionButton,
    CustomCallout,
    // eslint-disable-next-line vue/no-unused-components
    CustomDropDown,
    Pagination,
    FilterManager,
    customResultNotFound,
    Error,
    Dropdown,
    AdditionalInfo,
    LocationServiceInfo,
    VisitDetails,
  },
  mixins: [alertMixin, storeMixin],
  data: () => ({
    isPeriodFinalized: false, //set 'true' for finalized period
    page: {
      title: 'Finalización de Periodo',
      icon: 'fas fa-user-tie',
      routes: ['Proveedor', 'Finalización de Periodo'],
    },
    specialistInfoData: null,
    filterModel: {},
    locationServices: [],
    tabIndex: 0,
  }),
  computed: {
    ...mapGetters({
      pagination: 'getPagination',
    }),
    ...mapState({
      academicYears: (state) => state.catalog.academicYears,
      months: (state) => state.catalog.months,
      specialists: (state) => state.catalog.specialists,
      status: (state) => state.catalog.status,
      // filter: (state) => state.filter,
      currentFilter: (state) => state.currentFilter,
      results: (state) => state.filter.results,
      hasResults: (state) => state.filter.hasResults,
      specialistInfo: (state) => state.filter.specialistInfo,
      centers: (state) => state.catalog.centers,
      providers: (state) => state.catalog.providers,
      services: (state) => state.catalog.services,
    }),
    pageSize() {
      return DEFAULT_PAGE_SIZE;
    },
    isAdminProvider() {
      return [
        roles.AdminProvider,
        roles.AdminProInfo,
        roles.Administrador,
      ].includes(this.userRole);
    },
    isSpecialist() {
      return [roles.Especialista].includes(this.userRole);
    },
    isProvider() {
      return [roles.Provider, roles.AsistenteProveedor].includes(this.userRole);
    },
    getStatus() {
      return [
        { id: 1, name: 'No Finalizados' },
        { id: 2, name: 'Finalizados' },
      ];
    },
    isVisitType() {
      return (item) =>
        item.transactionType == thrpyBillingTransactionType.Visit;
    },
    getActionButtonLabel() {
      return this.specialistInfoData.finalizedFlag
        ? 'Reiniciar Periodo'
        : 'Finalizar Periodo';
    },
    getPeriodIndicatorLabel() {
      return this.specialistInfoData.finalizedFlag
        ? 'Periodo Finalizado'
        : 'Periodo No Finalizado';
    },
    getPeriodIndicatorStatusLabel() {
      return this.getPeriodEndStatusLabel(this.specialistInfoData.status);
    },
    getPeriodIndicatorStatusClass() {
      return this.specialistInfoData.status == periodEndStatus.Pending
        ? 'specialist-container__pending'
        : 'specialist-container__in-process';
    },
    canShowStatus() {
      return (
        this.specialistInfoData.status == periodEndStatus.Pending ||
        this.specialistInfoData.status == periodEndStatus.InProcess
      );
    },
    getPeriodIndicatorClass() {
      return this.specialistInfoData.finalizedFlag
        ? 'specialist-container__no-finalized'
        : 'specialist-container__finalized';
    },
    getButtonIcon() {
      return this.specialistInfoData.finalizedFlag
        ? 'fa fa-undo-alt'
        : 'fa fa-check-circle';
    },
    getBorderColor() {
      return this.specialistInfoData.finalizedFlag ? 'green' : 'gray';
    },
    toggleClass() {
      return (isOpen) => ({
        'far fa-chevron-circle-right orange-color': !isOpen,
        'far fa-chevron-circle-down green-color': isOpen,
      });
    },
    filterManagerConfig() {
      return {
        basic: [
          {
            name: 'academicYear',
            component: 'CustomDropDown',
            options: this.academicYears,
            initialValue: this.filterModel.academicYear,
            placeholder: 'Seleccione el año',
            fieldName: 'name',
            fieldKey: 'id',
            clearable: false,
            class: 'col-md-2',
          },
          {
            name: 'month',
            component: 'CustomDropDown',
            options: this.months,
            initialValue: this.filterModel.month,
            placeholder: 'Seleccione el mes',
            fieldName: 'name',
            fieldKey: 'id',
            clearable: false,
            class: 'col-md-2',
            validations: 'required',
            error: 'El mes es requerido.',
          },
          {
            name: 'provider',
            component: 'CustomDropDown',
            options: this.providers,
            disabled: this.providers && this.providers.length == 1,
            initialValue: this.filterModel.provider,
            placeholder: 'Seleccione Proveedor',
            fieldName: 'name',
            fieldKey: 'id',
            clearable: false,
            class: 'col-md-3',
            validations: 'required',
            error: 'El proveedor es requerido.',
          },
          {
            name: 'specialist',
            component: 'CustomDropDown',
            options: this.specialists,
            disabled: this.isSpecialist,
            initialValue: this.filterModel.specialist,
            placeholder: 'Seleccione Especialista',
            fieldName: 'name',
            fieldKey: 'id',
            clearable: false,
            class: 'col-md-3',
            validations: 'required',
            error: 'El especialista es requerido.',
          },
          {
            name: 'visitError',
            component: 'CheckBox',
            class: 'col-md-2',
            initialValue: this.filterModel.visitError,
            props: { text: 'Error en visita' },
          },
        ],
        advanced: [
          {
            name: 'status',
            component: 'CustomDropDown',
            options: this.getStatus,
            initialValue: this.filterModel.status,
            class: 'col-md-2',
            label: 'Estatus:',
            placeholder: 'Seleccione',
            fieldName: 'name',
            fieldKey: 'id',
            isAdvanced: true,
            validations: 'required',
            error: 'El estatus es requerido.',
          },
          {
            name: 'center',
            component: 'CustomDropDown',
            options: this.centers,
            initialValue: this.filterModel.center,
            placeholder: 'Seleccione',
            fieldName: 'name',
            fieldKey: 'id',
            clearable: false,
            class: 'col-md-3',
            label: 'Centro:',
            validations: 'required',
            error: 'El centro es requerido.',
            isAdvanced: true,
          },
          {
            name: 'locationService',
            component: 'CustomDropDown',
            options: this.locationServices,
            initialValue: this.filterModel.locationService,
            placeholder: 'Seleccione',
            fieldName: 'name',
            fieldKey: 'id',
            clearable: false,
            class: 'col-md-2',
            label: 'Lugar de Servicio:',
            validations: 'required',
            error: 'El lugar de servicio es requerido.',
            isAdvanced: true,
            visible: this.hasLevelLocation,
            disabled:
              this.locationServices && this.locationServices.length == 1,
          },
          {
            name: 'service',
            component: 'CustomDropDown',
            options: this.services,
            initialValue: this.filterModel.service,
            class: 'col-md-3',
            label: 'Servicio:',
            placeholder: 'Seleccione',
            fieldName: 'name',
            fieldKey: 'id',
            validations: 'required',
            error: 'El servicio es requerido.',
            isAdvanced: true,
          },
          {
            name: 'sie',
            component: 'CustomInput',
            icon: 'fas fa-search color-primary-2',
            class: 'col-12',
            leftIcon: true,
            label: this.isEducativeService(this.filterModel?.service?.id)
              ? 'Número de Solicitud o SIE'
              : 'Número de Referido o SIE:',
            placeholder: this.isEducativeService(this.filterModel?.service?.id)
              ? 'Escriba Número de Solicitud o SIE'
              : 'Escriba Número de Referido o SIE.',
            initialValue: this.filterModel.sie,
            isAdvanced: true,
          },
        ],
      };
    },
    getCompanyId() {
      return (
        this.$store.state['$_user'].user.profile.companyid ||
        this.filterModel.provider?.id
      );
    },
    getUserRelatedCompanies() {
      return this.$store.state['$_user'].companies;
    },
    isReadOnlyServices() {
      return this.specialistInfo?.services?.length == 1 ? false : true;
    },
    isReadOnlyCenters() {
      return this.specialistInfo?.centers?.length == 1 ? false : true;
    },
    isEducativeService() {
      return (serviceId) =>
        [disciplineTypeCodes.ServicioEducativo].includes(serviceId);
    },
    InterventionPlanNotSubmitedValidation() {
      return this.results.some((item) =>
        this.isInterventionPlanNotSubmited(item)
      );
    },
    canFinalizePeriod() {
      return (
        this.specialistInfoData.status != periodEndStatus.InProcess &&
        this.specialistInfoData.status != periodEndStatus.Pending //&&
        //this.userHasPermissions('provider.periodend')
      );
    },
    isPeiSignedValidation() {
      return this.results.some(
        (x) => x.isEducativeService && !x.isPeiSigned && !x.isItinerantService
      );
    },
    hasLevelLocation() {
      return this.userHasPermissions('level.location');
    },
    actionItems() {
      return [
        {
          label: 'Entrar',
          icon: 'fa fa-file-import text-green',
          visible: ({ item }) => this.isVisitType(item),
          click: ({ item, index }) => this.editItem(item, index),
        },
        {
          label: 'Detalle de visita',
          icon: 'fa fa-info-circle text-green ',
          visible: true,
          click: ({ item, index }) => {
            this.tabIndex = 1;
            if (!item.isOpen) {
              this.onToggleAdditionalInfo(item, index);
            }
          },
        },
      ];
    },
  },
  watch: {
    academicYears() {
      if (
        this.filterModel.academicYear == null &&
        this.academicYears.length > 0
      ) {
        this.filterModel.academicYear = this.currentAcademicYear();
        this[ACTION_TYPES.GET_MONTHS](this.filterModel.academicYear);
        this.validateSingleFilter();
      }
    },
    specialistInfo(val) {
      this.specialistInfoData = val;
    },
  },
  mounted() {
    this[ACTION_TYPES.GET_ACADEMIC_YEARS]();
    this.validateSingleFilter();
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    ...mapMutations([
      MUTATION_TYPES.SET_CLEAR_CATALOG,
      MUTATION_TYPES.SET_ADDITIONAL_INFO,
      MUTATION_TYPES.SET_PROVIDERS,
      MUTATION_TYPES.SET_SPECIALIST,
      MUTATION_TYPES.SET_ACADEMIC_YEARS,
    ]),
    ...mapActions([
      ACTION_TYPES.GET_ACADEMIC_YEARS,
      ACTION_TYPES.GET_MONTHS,
      ACTION_TYPES.GET_SPECIALIST,
      ACTION_TYPES.GET_SPECIALIST2,
      ACTION_TYPES.GET_STATUS,
      ACTION_TYPES.GET_PERIOD_END_SUMMARY,
      ACTION_TYPES.FINALIZE_PERIOD,
      ACTION_TYPES.START_ENDED_PERIOD,
      ACTION_TYPES.GET_CENTERS,
      ACTION_TYPES.Get_PROVIDERS,
      ACTION_TYPES.GET_SERVICES,
    ]),
    onChangeAcademicYear(value) {
      this[ACTION_TYPES.GET_MONTHS](value);
      this.filterModel.academicYearId = value;

      //Clear
      this.filterModel.month = null;
      this.filterModel.specialist = null;
      this.filterModel.center = null;
      this.filterModel.service = null;

      //clear catalog
      this[MUTATION_TYPES.SET_CLEAR_CATALOG]({
        centers: [],
      });
      this[MUTATION_TYPES.SET_CLEAR_CATALOG]({
        services: [],
      });

      if (!this.isProvider) {
        this.filterModel.provider = null;
      }
      this.validateSingleFilter();
    },
    onChangeMonth(value) {
      this.filterModel.month = value;
      this.filterModel.specialist = null;
      this.filterModel.status = null;
      this.filterModel.center = null;
      this.filterModel.service = null;

      //clear catalog
      this[MUTATION_TYPES.SET_CLEAR_CATALOG]({
        centers: [],
      });
      this[MUTATION_TYPES.SET_CLEAR_CATALOG]({
        services: [],
      });
      this[MUTATION_TYPES.SET_CLEAR_CATALOG]({
        specialists: [],
      });

      if (this.isAdminProvider) {
        if (this.providers && this.providers.length == 1) {
          this.filterModel.provider = null;
        }
        this[MUTATION_TYPES.SET_CLEAR_CATALOG]({
          Providers: [],
        });
      }

      if (this.isProvider || this.hasLevelLocation) {
        this[ACTION_TYPES.GET_SPECIALIST]({
          academicYearId: this.filterModel.academicYear?.id,
          monthNumber: value?.monthNumber,
          payload: { companyId: this.filterModel.provider?.id },
        });
        if (this.hasLevelLocation) {
          this.getLocations();
        }
      } else if (this.isSpecialist) {
        this.setIsActualSpecialist();
        this[ACTION_TYPES.GET_CENTERS]({
          academicYearId: this.filterModel.academicYear?.id,
          monthNumber: value?.monthNumber,
          payload: {
            specialistId: this.filterModel.specialist?.id,
            companyId: this.filterModel.provider?.id,
          },
        });
      }
    },
    setIsActualSpecialist() {
      let specialistInfo = this.$store.state['$_user'].user.profile;

      let specialist = {
        id: specialistInfo.specialistId,
        name: specialistInfo.givenname,
        sortOrder: 1,
        selected: true,
        isDirty: false,
      };

      this[MUTATION_TYPES.SET_SPECIALIST]([specialist]);
      this.filterModel.specialist = this.specialists.find(
        (p) => p.id == specialist.id
      );
    },
    setIsActualProvider() {
      let companies = this.getUserRelatedCompanies;
      if (companies && companies.length == 1) {
        this.filterModel.provider = companies[0];

        this[MUTATION_TYPES.SET_PROVIDERS]([companies]);
      } else {
        this[ACTION_TYPES.Get_PROVIDERS]({
          academicYearId: this.filterModel.academicYear?.id,
          payload: {
            specialistId: this.filterModel.specialist?.id,
          },
        });
      }
    },
    validateSingleFilter() {
      this.setIsActualProvider();
      if (this.isSpecialist) {
        this.setIsActualSpecialist();
      }
    },

    onChangeSpecialist() {
      this.filterModel.center = null;
      this.filterModel.service = null;

      this[MUTATION_TYPES.SET_CLEAR_CATALOG]({
        services: [],
      });

      this[ACTION_TYPES.GET_CENTERS]({
        academicYearId: this.filterModel.academicYear?.id,
        monthNumber: this.filterModel.month.monthNumber,
        payload: {
          specialistId: this.filterModel.specialist?.id,
          companyid: this.filterModel.provider?.id,
        },
      });
      this.filterModel.service = null;
    },
    onChangeCenters() {
      this.filterModel.service = null;

      this[MUTATION_TYPES.SET_CLEAR_CATALOG]({
        services: [],
      });
      this[ACTION_TYPES.GET_SERVICES]({
        payload: {
          academicYearId: this.filterModel.academicYear?.id,
          companyId: this.filterModel.provider?.id,
          monthDate: this.getMonthDate(),
          specialistId: Number(this.filterModel.specialist?.id),
          centerId: this.filterModel.center?.id,
        },
      });
    },

    onChangeProvider() {
      this.filterModel.center = null;
      this.filterModel.specialist = null;
      //clear catalog
      this[MUTATION_TYPES.SET_CLEAR_CATALOG]({
        centers: [],
      });
      this[MUTATION_TYPES.SET_CLEAR_CATALOG]({
        specialists: [],
      });
      this[ACTION_TYPES.GET_SPECIALIST]({
        academicYearId: this.filterModel.academicYear?.id,
        monthNumber: this.filterModel.month.monthNumber,
        payload: { companyId: this.filterModel.provider?.id },
      });
      this.getLocations();
    },
    filterOnChange(item) {
      this[ACTION_TYPES.GET_PERIOD_END_SUMMARY]({
        payload: {
          academicYearId: item.academicYearId,
          monthDate: item.monthDate,
          specialistId: item.specialistId,
          companyId: this.getCompanyId,
          centerId: item.centerId,
          disciplineTypeId: item.selectedService?.id,
          transactionType: item.selectedService?.transactionType,
        },
        persistSpecialistFilter: true,
      });
    },
    async onSearchHandler(model) {
      this.$refs.filter.advanced = true;
      await this.$forceUpdate();

      const isValid = await this.$refs.filter.$refs.formValidator.validate();
      if (!isValid) {
        await this.$refs.filter.$refs.formValidator.reset();
        await this.$refs.filter.$refs.formValidator.validate();
        this.ShowToast('Error', 'Información Incompleta', 'error');
        return;
      }

      if (model) {
        this[ACTION_TYPES.GET_PERIOD_END_SUMMARY]({
          payload: {
            academicYearId: this.filterModel.academicYear?.id,
            monthDate: this.getMonthDate(),
            specialistId: this.filterModel.specialist?.id,
            centerId: this.filterModel.center?.id,
            finalized: this.filterModel.status
              ? this.filterModel.status.id == 1
                ? false
                : true
              : null,
            status: this.filterModel.status ? this.filterModel.status.id : null,
            companyId: this.filterModel.provider?.id,
            disciplineTypeId: this.filterModel.service?.id,
            transactionType: this.filterModel.service?.transactionType,
            referralNumber: this.filterModel.sie,
            visitErrorFlag: this.filterModel.visitError,
            locationServiceId: this.filterModel.locationService?.id,
            pageIndex: 1,
            pageSize: 15,
          },
        });
      }
    },
    onToggleAdditionalInfo(item, index) {
      this[MUTATION_TYPES.SET_ADDITIONAL_INFO](index);
    },
    getMonthDescription(monthNumber, year) {
      let yearDesc = monthNumber > 6 ? year.split('-')[0] : year.split('-')[1];
      let monthDesc = moment()
        .set({ month: monthNumber - 1 })
        .format('MMMM')
        .replace(/\b\w/g, (l) => l.toUpperCase());
      return monthDesc + ' ' + yearDesc;
    },
    async editItem(item) {
      const month = this.getMonthDescription(
        this.filterModel.month.monthNumber,
        item.academicYearDescription
      );
      const { data: studentInfo } = await getVisitStudentInfo(
        item.studentServiceId,
        this.filterModel.academicYear.id,
        month,
        item.admissionId
      );
      const currentPeriodYear = moment(item.academicYearStartDate).year();

      //list of periods to disabled
      const disabledPeriods = this.months
        .slice(_.findIndex(this.months, { id: this.filterModel.month.id }) + 1)
        .map(({ monthNumber, year }) =>
          moment()
            .date(1)
            .month(monthNumber - 1)
            .year(year)
            .toDate()
        );

      const academicYearDescription = item.academicYearDescription;
      const monthNumber = this.filterModel.month.monthNumber;

      this.$router.push({
        name: VISIT_VALIDATION_ROUTE_NAME,
        params: {
          ...item,
          ...studentInfo,
          academicYearId: this.filterModel.academicYear.id,
          visitStudentServiceId: item.studentServiceId,
          specialistId: item.specialistId,
          companyId: item.companyId,
          centerId: item.serviceCenterId,
          disciplineTypeId: item.disciplineTypeCd,
          serviceDate: month,
          initialPeriodInfo: {
            year: currentPeriodYear,
            monthNumber: this.filterModel.month.monthNumber,
          },
          currentPeriod: {
            year: parseInt(
              monthNumber > 6
                ? academicYearDescription.split('-')[0]
                : academicYearDescription.split('-')[1]
            ),
            monthNumber,
          },
          disabledPeriods,
          initialPeriod: this.months[0],
          filter: this.filterModel,
        },
      });
    },
    goToPageHandler(page) {
      this[ACTION_TYPES.GET_PERIOD_END_SUMMARY]({
        payload: {
          academicYearId: this.filterModel.academicYear?.id,
          monthDate: this.getMonthDate(),
          specialistId: this.filterModel.specialist?.id,
          companyId: this.getCompanyId,
          centerId: this.specialistInfoData.centerId,
          disciplineTypeId: this.specialistInfoData.selectedService?.id,
          finalized: this.filterModel.status
            ? this.filterModel.status.id == 1
              ? false
              : true
            : null,
          status: this.filterModel.status ? this.filterModel.status.id : null,
          transactionType: this.filterModel.service?.transactionType,
          referralNumber: this.filterModel.sie,
          visitErrorFlag: this.filterModel.visitError,
          pageIndex: page,
          pageSize: 15,
        },
        persistSpecialistFilter: true,
      });
    },

    async callFinalizeProcess() {
      if (this.InterventionPlanNotSubmitedValidation) {
        this.ShowToast(
          'Error',
          'No cuenta con un plan de intervención. Favor de registrar un plan de intervencion antes de finalizar periodo.',
          'error'
        );
        return;
      }
      // else if (this.isPeiSignedValidation) { --- Temp--- Don't remove commented
      //   this.ShowToast(
      //     'Error',
      //     'El perí­odo no puede ser finalizado ya que uno o más estudiantes no cuentan con un PEI firmado de la Institución para el año corriente.',
      //     'error'
      //   );
      //   return;
      // }

      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea finalizar el periodo seleccionado?',
        'Si',
        'No'
      );
      if (answer) {
        const { isValid, message } = await this[ACTION_TYPES.FINALIZE_PERIOD]({
          payload: {
            academicYearId: this.filterModel.academicYear?.id,
            companyId: this.getCompanyId,
            finalized: true,
            monthDate: this.getMonthDate(),
            specialistId: this.filterModel.specialist?.id,
            centerId: this.specialistInfoData.centerId,
            billingServiceCenterId: this.specialistInfoData.centerId,
          },
        });
        if (!isValid) {
          this.ShowToast('Error', message, 'error');
          this.onSearchHandler(this.filterModel);
        } else {
          this.ShowToast(
            'Proceso exitoso.',
            'Comenzó el proceso de finalización de periodo exitosamente. Una vez culmine el proceso de validación se enviará un correo electrónico notificando el detalle de la finalización.',
            'success'
          );
          this.specialistInfoData.status = periodEndStatus.Pending;
          this.onSearchHandler(this.filterModel);
        }
      }
    },
    async callStartEndedProcess() {
      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea reiniciar el periodo seleccionado?',
        'Si',
        'No'
      );
      if (answer) {
        const { isValid, message } = await this[
          ACTION_TYPES.START_ENDED_PERIOD
        ]({
          payload: {
            academicYearId: this.specialistInfoData.academicYearId,
            companyId: this.specialistInfoData.companyId,
            finalized: false,
            monthDate: this.specialistInfoData.monthDate,
            specialistId: this.specialistInfoData.specialistId,
            centerId: this.specialistInfoData.centerId,
            billingServiceCenterId: this.specialistInfoData.centerId,
          },
        });
        if (!isValid) {
          this.ShowToast('Error', message, 'error');
        } else {
          this.ShowToast(
            'Proceso exitoso.',
            'El periodo fue reiniciado exitosamente.',
            'success'
          );
          this.specialistInfoData.finalizedFlag = false;
          this.specialistInfoData.status = periodEndStatus.NotFinalized;
          this.filterModel.status = { id: 1, name: 'No Finalizados' };
        }
      }
    },
    async doAction() {
      if (!this.specialistInfoData.finalizedFlag) {
        await this.callFinalizeProcess();
      } else {
        await this.callStartEndedProcess();
      }
    },
    getMonthDate() {
      return moment()
        .set({
          month: this.filterModel.month?.monthNumber - 1,
          date: 1,
          year: this.filterModel.month?.year,
        })
        .toDate();
    },
    isInterventionPlanNotSubmited(item) {
      return (
        this.filterModel.month.monthNumber != 6 &&
        item.isInterventionPlanSubmitted === false &&
        item.transactionType == 1 &&
        !item.isEducativeService &&
        !item.planStatusDocumentIdInd &&
        !item.planStatusItemAttachInd
      );
    },
    getPeriodEndStatusLabel(status) {
      switch (status) {
        case periodEndStatus.Finalized:
          return 'Periodo Finalizado';
        case periodEndStatus.NotFinalized:
          return 'Periodo No Finalizado';
        case periodEndStatus.InProcess:
          return 'En Proceso';
        case periodEndStatus.Pending:
          return 'Pendiente';
        default:
          return '';
      }
    },
    dateFormat: function(date) {
      if (date) {
        return moment(date)
          .locale('es-PR')
          .format('DD/MMM/YYYY');
      }
      return '';
    },
    async getLocations() {
      const { data } = await _getServiceLocations(
        this.filterModel.provider.id,
        null,
        null,
        this.filterModel.academicYear.id
      );
      this.locationServices = data;

      if (this.locationServices.length === 1) {
        this.filterModel.locationService = this.locationServices[0];
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
$collapseOpenColor: #bcbec0;
$collapseCloseColor: #ff7058;
$colorWhite: #fff;
$panelBorderColor: #f2f2f2;
$errorColor: #c5525c;

.specialist-container {
  border-radius: 5px;

  &__pending {
    background: #f8b539;
    border-radius: 50px;
    padding: 10px;
    span {
      color: map-get($colors, 'white');
    }
  }

  &__in-process {
    background: #2db782;
    border-radius: 50px;
    padding: 10px;
    span {
      color: map-get($colors, 'white');
    }
  }

  &__finalized {
    background: #b5c3bc;
    border-radius: 50px;
    padding: 10px;
    span {
      color: map-get($colors, 'white');
    }
  }

  &__no-finalized {
    background: none;
    border-radius: 50px;
    border: 1px solid map-get($colors, 'green');
    padding: 10px;
    span {
      color: #36484b;
    }
  }

  &__provider {
    background: map-get($colors, 'white');
    border-radius: 3px;
  }
}

.dot {
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 27px;
  height: 27px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: map-get($colors, 'white');
  display: inline-block;
  margin-right: 15px;
  .title-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1px;
    font-size: 20px;
  }
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 86px;
  .toggle-icon {
    flex: 1;
    text-align: center;
    cursor: pointer;
    em {
      margin-top: 12px;
      font-size: 26px;
    }
  }
  .separator-line {
    background: transparent linear-gradient(270deg, #f7f7f700 0%, #efefef 100%)
      0% 0% no-repeat padding-box;
    opacity: 1;
    width: 10px;
    height: 100%;
  }
}

.orange-color {
  color: #ff7058;
}

.green-color {
  color: #2db782;
}

.text-black {
  color: #11291b;
}

.info-panel {
  padding: 15px 10px 1px 20px;
  .info-panel-main-title {
    em {
      color: $collapseCloseColor;
    }
    span {
      text-align: left;
      font: Bold 16px/19px Lato;
      letter-spacing: 0px;
      color: #3f5b60;
      opacity: 1;
      margin-left: 7px;
    }
  }
  .info-panel-container {
    display: flex;
    flex-flow: row wrap;
    padding: 15px 10px 1px 23px;
    .info-panel-item {
      flex: 1 0 20%;
      margin-bottom: 0.5em;
      float: left;
      box-sizing: border-box;
      padding-right: 10px;
      span {
        display: block;
        text-align: left;
        font: Regular 14px/28px Lato;
        letter-spacing: 0px;
        color: #727272;
      }
      label {
        text-align: left;
        font: Regular Lato;
        font-size: 1rem;
        letter-spacing: 0px;
        color: #11291b;
        line-height: 1.6em;
      }
    }
  }
}

.action-button {
  margin-left: 114px;
}
.student-spacing {
  margin-right: -60px;
}
.service-place-spacing {
  margin-right: -50px;
}

.error-indicator {
  margin-left: 10px;
  em {
    color: $errorColor;
  }
  span {
    font-size: 14px;
    color: $errorColor;
    margin-left: 5px;
  }
}

/* overrides */
.custom-callout {
  .col-spacing {
    padding: 20px 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  ::v-deep .callout-container {
    padding: 0px !important;
    border-left-width: 4px;
  }
  ::v-deep .callout-edition {
    margin-top: 3px !important;
    padding: 7px !important;
  }
}

::v-deep .custom-nav-container {
  border-bottom: 1px solid map-get($colors, 'gray-5');
  .nav-item {
    .nav-link {
      color: map-get($colors, 'secondary-6');
      &.active {
        border-bottom: 3px solid map-get($colors, 'orange');
        color: map-get($colors, 'orange');
      }
      &.active:after {
        content: unset;
      }
    }
  }
}

.no-info {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-left-style: solid;
  border-color: #e8e8e8;
  border-width: 0;
  .no-info-text {
    text-align: left;
    font: Bold 16px/22px Lato;
    letter-spacing: 0;
    color: #727272;
    opacity: 1;
  }
  .no-info-icon {
    color: #727272;
    font-size: 32px;
  }
}
.transparent-color {
}
.transparent-color:hover {
  color: #2db782 !important;
}

.indicator-size {
  max-width: 200px;
}

.visit-error-container {
  background: #fae7e7;
  padding: 10px;
  border-radius: 0px 0px 5px 5px;
  margin-top: -16px;
  margin-bottom: 20px;
}

@media only screen and (max-width: 768px) {
  .action-button {
    margin-left: 0px;
  }
}
</style>
